import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { openModal } from 'redux/modules/shipper-order-documents/effects';

import Documents from './component';

const enhance = compose(injectIntl);

const DocumentsWithIntl = enhance(Documents);

export default connect(() => ({}), { openModal })(DocumentsWithIntl);
